import { render, staticRenderFns } from "./ProductFees.vue?vue&type=template&id=1989504c&"
import script from "./ProductFees.vue?vue&type=script&lang=js&"
export * from "./ProductFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports